import React, { useState } from 'react';
import { useEffect } from 'react';
import ReactQuill from "react-quill"

import { Button } from './button';
import { saveDescriptions } from './personapi';
import { getDescription } from '../precalc/precalcApi';

export function DescriptionCompany() {
    const [messageRes, setMessageRes] = useState('')

    const [absolutProperty, setAbsolutProperty] = useState('')
    const [absolutLife, setAbsolutLife] = useState('')
    const [zettaProperty, setZettaProperty] = useState('')
    const [zettaLife, setZettaLife] = useState('')
    const [alfaProperty, setAlfaProperty] = useState('')
    const [alfaLife, setAlfaLife] = useState('')
    const [pariProperty, setPariProperty] = useState('')
    const [pariLife, setPariLife] = useState('')
    const [ingosProperty, setIngosProperty] = useState('')
    const [ingosLife, setIngosLife] = useState('')

    const [absolutPropertyRaiting, setAbsolutPropertyRaiting] = useState(0)
    const [absolutLifeRaiting, setAbsolutLifeRaiting] = useState(0)
    const [zettaPropertyRaiting, setZettaPropertyRaiting] = useState(0)
    const [zettaLifeRaiting, setZettaLifeRaiting] = useState(0)
    const [alfaPropertyRaiting, setAlfaPropertyRaiting] = useState(0)
    const [alfaLifeRaiting, setAlfaLifeRaiting] = useState(0)
    const [pariPropertyRaiting, setPariPropertyRaiting] = useState(0)
    const [pariLifeRaiting, setPariLifeRaiting] = useState(0)
    const [ingosPropertyRaiting, setIngosPropertyRaiting] = useState(0)
    const [ingosLifeRaiting, setIngosLifeRaiting] = useState(0)
    

    const handleSaveDescription = () => {
        saveDescriptions({
            absolutProperty: absolutProperty,
            absolutLife: absolutLife,
            zettaProperty: zettaProperty,
            zettaLife: zettaLife,
            alfaProperty: alfaProperty,
            alfaLife: alfaLife,
            pariProperty: pariProperty,
            pariLife: pariLife,
            ingosProperty: ingosProperty,
            ingosLife: ingosLife,
            absolutPropertyRaiting: absolutPropertyRaiting,
            absolutLifeRaiting: absolutLifeRaiting,
            zettaPropertyRaiting: zettaPropertyRaiting,
            zettaLifeRaiting: zettaLifeRaiting,
            alfaPropertyRaiting: alfaPropertyRaiting,
            alfaLifeRaiting: alfaLifeRaiting,
            pariPropertyRaiting: pariPropertyRaiting,
            pariLifeRaiting: pariLifeRaiting,
            ingosPropertyRaiting: ingosPropertyRaiting,
            ingosLifeRaiting: ingosLifeRaiting,
        }, (data) => {
            setMessageRes('Сохранено')
        })
    }

    

    const handleGetDescription = () => {
        getDescription({}, (data) => {
            setAbsolutProperty(data.descriptions['absolutproperty']?.description)
            setAbsolutLife(data.descriptions['absolutlife']?.description)
            setZettaProperty(data.descriptions['zettaproperty']?.description)
            setZettaLife(data.descriptions['zettalife']?.description)
            setPariProperty(data.descriptions['pariproperty']?.description)
            setPariLife(data.descriptions['parilife']?.description)
            setAlfaProperty(data.descriptions['alfaproperty']?.description)
            setAlfaLife(data.descriptions['alfalife']?.description)
            setIngosProperty(data.descriptions['ingosproperty']?.description)
            setIngosLife(data.descriptions['ingoslife']?.description)

            setAbsolutPropertyRaiting(data.descriptions['absolutproperty']?.raiting_pop)
            setAbsolutLifeRaiting(data.descriptions['absolutlife']?.raiting_pop)
            setZettaPropertyRaiting(data.descriptions['zettaproperty']?.raiting_pop)
            setZettaLifeRaiting(data.descriptions['zettalife']?.raiting_pop)
            setPariPropertyRaiting(data.descriptions['pariproperty']?.raiting_pop)
            setPariLifeRaiting(data.descriptions['parilife']?.raiting_pop)
            setAlfaPropertyRaiting(data.descriptions['alfaproperty']?.raiting_pop)
            setAlfaLifeRaiting(data.descriptions['alfalife']?.raiting_pop)
            setIngosPropertyRaiting(data.descriptions['ingosproperty']?.raiting_pop)
            setIngosLifeRaiting(data.descriptions['ingoslife']?.raiting_pop)
        })
    }

    useEffect(() => {
        handleGetDescription()
    }, []);

    return (
        <>
            <h4>Описание страховых</h4>
            <div className='bg-w brd-r5 mt-4 p-2'>
                            <h5>СК Абсолют</h5>
                            
                            <div className='row'>
                                <div className='w-50'>
                                    <div className='row m-0 p-0 d-flex align-items-center'>
                                        <label for="basic-url" className="form-label w-50 p-0">Имущество</label>
                                        <div class="input-group mb-3 w-50 p-0 m-0">
                                            <span class="input-group-text">Популярность</span>
                                            <input type='number' class="form-control" value={absolutPropertyRaiting} onChange={(e)=>setAbsolutPropertyRaiting(e.target.value)}/>
                                        </div>
                                    </div>
                                    
                                    <div className="input-group mb-3 ">
                                        {/* <input type="text" className="form-control" value={absolutProperty} onChange={handleChangeAbsolutProperty}/> */}

                                        <ReactQuill
                                            theme='snow'
                                            value={absolutProperty}
                                            onChange={setAbsolutProperty}
                                            style={{height: '200px'}}
                                        />
                                    </div>
                                </div>
                                <div className='w-50'>
                                    
                                    <div className='row m-0 p-0 d-flex align-items-center'>
                                        <label for="basic-url" className="form-label w-50 p-0">Жизнь</label>
                                        <div class="input-group mb-3 w-50 p-0 m-0">
                                            <span class="input-group-text">Популярность</span>
                                            <input type='number' className="form-control" value={absolutLifeRaiting} onChange={(e) => setAbsolutLifeRaiting(e.target.value)}/>
                                        </div>
                                    </div>
                                    <div className="input-group mb-3 ">
                                        {/* <input type="text" className="form-control" value={absolutLife} onChange={handleChangeAbsolutLife}/> */}
                                        <ReactQuill
                                            theme='snow'
                                            value={absolutLife}
                                            onChange={setAbsolutLife}
                                            style={{height: '200px'}}
                                        />
                                    </div>
                                </div>
                            </div>
                            

                            

                            <h5 className='mt-5'>Зетта Страхование</h5>

                            <div className='row'>                            
                                <div className='w-50'>
                                    <div className='row m-0 p-0 d-flex align-items-center'>
                                        <label for="basic-url" className="form-label w-50 p-0">Имущество</label>
                                        <div class="input-group mb-3 w-50 p-0 m-0">
                                            <span class="input-group-text">Популярность</span>
                                            <input type='number' class="form-control" value={zettaPropertyRaiting} onChange={(e) => setZettaPropertyRaiting(e.target.value)}/>
                                        </div>
                                    </div>
                                    <div className="input-group mb-3 ">
                                        <ReactQuill
                                            theme='snow'
                                            value={zettaProperty}
                                            onChange={setZettaProperty}
                                            style={{height: '200px', width: '100%'}}
                                        />
                                    </div>
                                </div>
                                <div className='w-50'>
                                    <div className='row m-0 p-0 d-flex align-items-center'>
                                        <label for="basic-url" className="form-label w-50 p-0">Жизнь</label>
                                        <div class="input-group mb-3 w-50 p-0 m-0">
                                            <span class="input-group-text">Популярность</span>
                                            <input type='number' class="form-control" value={zettaLifeRaiting} onChange={(e) => setZettaLifeRaiting(e.target.value)}/>
                                        </div>
                                    </div>
                                    <div className="input-group mb-3 ">
                                        <ReactQuill
                                            theme='snow'
                                            value={zettaLife}
                                            onChange={setZettaLife}
                                            style={{height: '200px', width: '100%'}}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* <label for="basic-url" className="form-label">Имущество</label>
                            <div className="input-group mb-3 ">
                                <input type="text" className="form-control" value={zettaProperty} onChange={handleChangeZettaProperty}/>
                            </div>

                            <label for="basic-url" className="form-label">Жизнь</label>
                            <div className="input-group mb-3 ">
                                <input type="text" className="form-control" value={zettaLife} onChange={handleChangeZettaLife}/>
                            </div> */}

                            <h5 className='mt-5'>Альфа Страхование</h5>

                            <div className='row'>                            
                                <div className='w-50'>
                                    <div className='row m-0 p-0 d-flex align-items-center'>
                                        <label for="basic-url" className="form-label w-50 p-0">Имущество</label>
                                        <div class="input-group mb-3 w-50 p-0 m-0">
                                            <span class="input-group-text">Популярность</span>
                                            <input type='number' class="form-control" value={alfaPropertyRaiting} onChange={(e) => setAlfaPropertyRaiting(e.target.value)}/>
                                        </div>
                                    </div>
                                    <div className="input-group mb-3 ">
                                        <ReactQuill
                                            theme='snow'
                                            value={alfaProperty}
                                            onChange={setAlfaProperty}
                                            style={{height: '200px', width: '100%'}}
                                        />
                                    </div>
                                </div>
                                <div className='w-50'>
                                    <div className='row m-0 p-0 d-flex align-items-center'>
                                        <label for="basic-url" className="form-label w-50 p-0">Жизнь</label>
                                        <div class="input-group mb-3 w-50 p-0 m-0">
                                            <span class="input-group-text">Популярность</span>
                                            <input type='number' class="form-control" value={alfaLifeRaiting} onChange={(e) => setAlfaLifeRaiting(e.target.value)}/>
                                        </div>
                                    </div>
                                    <div className="input-group mb-3 ">
                                        <ReactQuill
                                            theme='snow'
                                            value={alfaLife}
                                            onChange={setAlfaLife}
                                            style={{height: '200px', width: '100%'}}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* <label for="basic-url" className="form-label">Имущество</label>
                            <div className="input-group mb-3 ">
                                <input type="text" className="form-control" value={alfaProperty} onChange={handleChangeAlfaProperty}/>
                            </div>

                            <label for="basic-url" className="form-label">Жизнь</label>
                            <div className="input-group mb-3 ">
                                <input type="text" className="form-control" value={alfaLife} onChange={handleChangeAlfaLife}/>
                            </div> */}

                            <h5 className='mt-5'>СК ПАРИ</h5>

                            <div className='row'>                            
                                <div className='w-50'>
                                    <div className='row m-0 p-0 d-flex align-items-center'>
                                        <label for="basic-url" className="form-label w-50 p-0">Имущество</label>
                                        <div class="input-group mb-3 w-50 p-0 m-0">
                                            <span class="input-group-text">Популярность</span>
                                            <input type='number' class="form-control" value={pariPropertyRaiting} onChange={(e) => setPariPropertyRaiting(e.target.value)}/>
                                        </div>
                                    </div>
                                    <div className="input-group mb-3 ">
                                        <ReactQuill
                                            theme='snow'
                                            value={pariProperty}
                                            onChange={setPariProperty}
                                            style={{height: '200px', width: '100%'}}
                                        />
                                    </div>
                                </div>
                                <div className='w-50'>
                                    <div className='row m-0 p-0 d-flex align-items-center'>
                                        <label for="basic-url" className="form-label w-50 p-0">Жизнь</label>
                                        <div class="input-group mb-3 w-50 p-0 m-0">
                                            <span class="input-group-text">Популярность</span>
                                            <input type='number' class="form-control" value={pariLifeRaiting} onChange={(e) => setPariLifeRaiting(e.target.value)}/>
                                        </div>
                                    </div>
                                    <div className="input-group mb-3 ">
                                        <ReactQuill
                                            theme='snow'
                                            value={pariLife}
                                            onChange={setPariLife}
                                            style={{height: '200px', width: '100%'}}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* <label for="basic-url" className="form-label">Имущество</label>
                            <div className="input-group mb-3 ">
                                <input type="text" className="form-control" value={pariProperty} onChange={handleChangePariProperty}/>
                            </div>

                            <label for="basic-url" className="form-label">Жизнь</label>
                            <div className="input-group mb-3 ">
                                <input type="text" className="form-control" value={pariLife} onChange={handleChangePariLife}/>
                            </div> */}

                            <h5 className='mt-5'>Ингосстрах</h5>
                            
                            <div className='row'>                            
                                <div className='w-50'>
                                    <div className='row m-0 p-0 d-flex align-items-center'>
                                        <label for="basic-url" className="form-label w-50 p-0">Имущество</label>
                                        <div class="input-group mb-3 w-50 p-0 m-0">
                                            <span class="input-group-text">Популярность</span>
                                            <input type='number' class="form-control" value={ingosPropertyRaiting} onChange={(e) => setIngosPropertyRaiting(e.target.value)}/>
                                        </div>
                                    </div>
                                    <div className="input-group mb-3 ">
                                        <ReactQuill
                                            theme='snow'
                                            value={ingosProperty}
                                            onChange={setIngosProperty}
                                            style={{height: '200px', width: '100%'}}
                                        />
                                    </div>
                                </div>
                                <div className='w-50'>
                                    <div className='row m-0 p-0 d-flex align-items-center'>
                                        <label for="basic-url" className="form-label w-50 p-0">Жизнь</label>
                                        <div class="input-group mb-3 w-50 p-0 m-0">
                                            <span class="input-group-text">Популярность</span>
                                            <input type='number' class="form-control" value={ingosLifeRaiting} onChange={(e) => setIngosLifeRaiting(e.target.value)}/>
                                        </div>
                                    </div>
                                    <div className="input-group mb-3 ">
                                        <ReactQuill
                                            theme='snow'
                                            value={ingosLife}
                                            onChange={setIngosLife}
                                            style={{height: '200px', width: '100%'}}
                                        />
                                    </div>
                                </div>
                            </div>

                            
                            {/* <label for="basic-url" className="form-label">Имущество</label>
                            <div className="input-group mb-3 ">
                                <input type="text" className="form-control" value={ingosProperty} onChange={handleChangeIngosProperty}/>
                            </div>

                            <label for="basic-url" className="form-label">Жизнь</label>
                            <div className="input-group mb-3 ">
                                <input type="text" className="form-control" value={ingosLife} onChange={handleChangeIngosLife}/>
                            </div> */}
                            
                            <div className='ms-0 row  d-flex justify-content-end'>
                                <div className='w-25 m-0 p-3'>
                                    <Button handleClick={handleSaveDescription} text={'Сохранить'}/>
                                    <div className='h-text d-flex justify-content-center'>
                                        {messageRes}
                                    </div>
                                </div>
                            </div>

                        </div>
        </>
    )
}
